import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiWrapperTableCellBase } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-cell-base';
import { IPublicationItemBase } from '@fi-shared/models/models';
import { SharedActionsBaseService } from '@fi-shared/fi-shared-services/shared-actions-base.service';

@Component({
    selector: 'fi-wrapper-table-published-cell',
    templateUrl: './fi-wrapper-table-published-cell.component.html',
    styleUrls: ['./fi-wrapper-table-published-cell.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-wrapper-table-published-cell' },
    standalone: false,
})
export class FiWrapperTablePublishedCellComponent extends FiWrapperTableCellBase<IPublicationItemBase> {
    constructor(private sharedActionsService: SharedActionsBaseService) {
        super();
    }

    openUserViewDialog($event: MouseEvent, userId: number) {
        $event.stopPropagation();
        this.sharedActionsService.openUserViewPopup(userId);
    }
}
